import { TENANTS } from "../../../constants"
import { loc } from "../../../core/utils"
import { setIn } from "final-form"
import * as yup from "yup"

function yupErrorsToFinalForm(yupError) {
  if (!yupError?.inner?.length) return {}
  return yupError.inner
    .filter((field) => field.errors.length > 0)
    .reduce((errors, errorField) => setIn(errors, errorField.path, errorField.message), {})
}

/**
 * Validation des champs page finale PDI Retail selon configuration et tenant.
 */
export async function validateFinalPageFormValues(values, ctx) {
  const { norm, tenant, order, opl } = ctx
  const shape = {}
  const req = () => loc("Required")
  const maxChar = (n) => `${n} ${loc("maximum characters")}`
  if (norm.id_commande_distributeur) {
    const hasDistributorOrderCommitted =
      Boolean(order?.supplierBillNumber) ||
      (Boolean(order?.supplierOrderNumber) &&
        String(order.supplierOrderNumber).trim() !== "" &&
        opl != null &&
        order.supplierOrderNumber !== opl)
    if (!hasDistributorOrderCommitted) {
      if (tenant === TENANTS.MEDIAMARKT_NL || tenant === TENANTS.MEDIAMARKT_BE) {
        shape.supplierOrderNumber = yup
          .string()
          .required(req())
          .matches(/^\d{8}$/, loc("pdi_retail_mm_order_digits"))
      } else {
        shape.supplierOrderNumber = yup.string().required(req()).max(50, maxChar(50))
      }
    }
  }

  if (norm.numero_marquage) {
    shape.numero_marquage = yup.string().nullable().required(req()).max(255, maxChar(255))
  }

  if (norm.imei) {
    shape.imei = yup.string().nullable().required(req()).max(255, maxChar(255))
  }

  if (tenant === TENANTS.CONFORAMA_RETAIL && norm.supplier_bill_number) {
    shape.supplierBillNumber = yup.string().nullable().required(req()).max(255, maxChar(255))
  }

  if (Object.keys(shape).length === 0) return null

  try {
    await yup.object({ finalPageForm: yup.object().shape(shape) }).validate(values, { abortEarly: false })
    return null
  } catch (e) {
    return yupErrorsToFinalForm(e)
  }
}
